export default [
  {
    path: "/",
    name: "360",
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/",
    name: "indexs",
    component: () => import("@/views/Home/index.vue"),
    redirect: "/home/index",
    children: [
      // 首页
      {
        path: "/home",
        name: "homes",
        meta: {
          keepAlive: false,
        },
        component: () => import("@/views/Indexs/index.vue"),
      },
      // 资讯
      {
        path: "/news",
        name: "news",
        meta: {
          keepAlive: false,
        },
        component: () => import("@/views/News/index.vue"),
      },
      // 资讯
      {
        path: "/996news",
        name: "996news",
        component: () => import("@/views/News/index.vue"),
      },
      // 资讯详情
      {
        path: "/newsDetail",
        name: "newsDetail",
        component: () => import("@/views/News/newsDetail.vue"),
      },
      // 关于我们
      {
        path: "/aboutUs",
        name: "aboutUs",
        component: () => import("@/views/BottomInfo/aboutUs.vue"),
      },
      // 产品介绍
      {
        path: "/productInfo",
        name: "productInfo",
        component: () => import("@/views/BottomInfo/productInfo.vue"),
      },
      // 联系我们
      {
        path: "/contactUs",
        name: "contactUs",
        component: () => import("@/views/BottomInfo/contactUs.vue"),
      },
      // 服务条款
      {
        path: "/permit",
        name: "permit",
        component: () => import("@/views/BottomInfo/permit.vue"),
      },
      // 软件许可协议
      {
        path: "/softwareLis",
        name: "softwareLis",
        component: () => import("@/views/BottomInfo/softwareLis.vue"),
      },
      // 隐私政策
      {
        path: "/privacy",
        name: "privacy",
        component: () => import("@/views/BottomInfo/privacy.vue"),
      },
      // 游戏详情页
      {
        path: "/GameDetail",
        name: "GameDetail",
        component: () => import("@/views/GameDetail/index.vue"),
      },
      // 直播
      {
        path: "/liveHome",
        name: "liveHome",
        component: () => import("@/views/LiveStreaming/liveHome/index.vue"),
      },
      // 直播详情
      {
        path: "/studio",
        name: "studio",
        component: () => import("@/views/LiveStreaming/studio/index.vue"),
      },
      // 百度
      {
        path: "/sw",
        name: "sw",
        component: () => import("@/views/sw/index.vue"),
      },
      // 百度
      {
        path: "/baidu",
        name: "baidu",
        component: () => import("@/views/pinzhuan/index.vue"),
      },
      // 百度
      {
        path: "/bd",
        name: "bd",
        component: () => import("@/views/bd/index.vue"),
      },
      // 百度-关于我们
      {
        path: "/bdAboutUs",
        name: "bdAboutUs",
        component: () => import("@/views/BottomInfo/aboutUs.vue"),
      },
      // 百度-产品介绍
      {
        path: "/bdproductInfo",
        name: "bdproductInfo",
        component: () => import("@/views/BottomInfo/productInfo.vue"),
      },
      // 百度-服务条款
      {
        path: "/bdpermit",
        name: "bdpermit",
        component: () => import("@/views/BottomInfo/permit.vue"),
      },
      // 百度-软件许可协议
      {
        path: "/bdsoftwareLis",
        name: "bdsoftwareLis",
        component: () => import("@/views/BottomInfo/softwareLis.vue"),
      },
      // 百度-隐私政策
      {
        path: "/bdprivacy",
        name: "bdprivacy",
        component: () => import("@/views/BottomInfo/privacy.vue"),
      },
      // 赛事直播
      // {
      //     path: '/competition',
      //     name: 'competition',
      //     component: () => import('@/views/LiveStreaming/competition/index.vue'),
      // },
      // 360pc
    ],
  },
  // 赛事直播
  {
    path: "/competition",
    name: "competition",
    component: () => import("@/views/LiveStreaming/competition/index.vue"),
  },
  {
    path: "/360",
    redirect: "/",
  },
  {
    path: "/360m",
    name: "360m",
    component: () => import("@/views/360/360mb/index.vue"),
  },
  {
    path: "/sougou",
    name: "sougou",
    component: () => import("@/views/360/sougou/index.vue"),
  },
  {
    path: "/msougou",
    name: "msougou",
    component: () => import("@/views/360/msougou/index.vue"),
  },
  {
    path: "/3601",
    name: "3601",
    component: () => import("@/views/360/3601/index.vue"),
  },
  {
    path: "/wm",
    name: "wm",
    component: () => import("@/views/360/wm/index.vue"),
  },
  {
    path: "/wb",
    name: "wb",
    component: () => import("@/views/360/wb/index.vue"),
  },
  {
    path: "/zdzm",
    name: "zdzm",
    component: () => import("@/views/360/zdzm/index.vue"),
  },
  {
    path: "/996",
    name: "996",
    component: () => import("@/views/996/index.vue"),
  },
  {
    path: "/uc",
    name: "uc",
    component: () => import("@/views/uc/index.vue"),
  },
];
